var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.188,
    height: 21.164,
    viewBox: "0 0 18.188 21.164",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report",
    transform: "translate(22497.771 7050.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5370",
    "data-name": "Path 5370",
    d: "M416.783,14.77h3.76l-3.957-3.887v3.69a.2.2,0,0,0,.2.2Zm0,0",
    transform: "translate(-22900.494 -7060.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5371",
    "data-name": "Path 5371",
    d: "M11.394,5.487A1.439,1.439,0,0,1,9.956,4.05V0H-.354A2.316,2.316,0,0,0-2.668,2.314V18.85A2.316,2.316,0,0,0-.354,21.164H13.206A2.316,2.316,0,0,0,15.52,18.85V5.487ZM9.976,16.038H1.99a.62.62,0,0,1,0-1.24H9.976a.62.62,0,1,1,0,1.24Zm-8.606-3.1a.62.62,0,0,1,.62-.62H9.117a.62.62,0,1,1,0,1.24H1.99A.62.62,0,0,1,1.37,12.938Zm9.36-1.86H1.99a.62.62,0,1,1,0-1.24h8.74a.62.62,0,1,1,0,1.24Zm0,0",
    transform: "translate(-22495.104 -7050.164)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Report.9720a9ad.svg";
export { ForwardRef as ReactComponent };